// third-party
import { configureStore } from '@reduxjs/toolkit';
import { useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';

import { persistStore } from 'redux-persist';

// project imports
import rootReducer from './reducer';

import { prefListenerMiddleware } from '../views/workspace/document/preferences/preferenceSlice';
import apiSlice from './slices/apiSlice';

const key = localStorage.getItem('DocsGPTApiKey');
const doc = localStorage.getItem('DocsGPTRecentDocs');

// ==============================|| REDUX - MAIN STORE ||============================== //

const store = configureStore({
    preloadedState: {
        preference: {
            apiKey: key ?? '',
            selectedDocs: doc !== null ? JSON.parse(doc) : null,
            conversations: null,
            sourceDocs: [
                {
                    location: '',
                    language: '',
                    name: 'default',
                    version: '',
                    dat: '',
                    description: '',
                    docLink: '',
                    fullName: '',
                    model: '1.0'
                }
            ]
        }
    },
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            immutableCheck: false
        }).concat(apiSlice.middleware, prefListenerMiddleware.middleware)
});

const persister = persistStore(store);

const { dispatch } = store;

const useDispatch = () => useAppDispatch();
const useSelector = useAppSelector;

export { store, persister, dispatch, useSelector, useDispatch };
